<template>
  <div class="knowledge-category">
    <div class="module-item-style knowledge-management-filter">
      <el-input placeholder="请输入内容" v-model="searchClass" class="input-search-problem">
        <el-button slot="append" icon="el-icon-search" @click="filterClass"></el-button>
      </el-input>
    </div>
    <div class="module-item-style table-data">
      <tableBox
          :tableData="tableData"
          :tableHead="tableHead"
          :tableHandler="tableHandler"
          :total="total"
          :size="pageSize"
          @handleButton="handleOperate"
          @pageHandler="pageOperate"></tableBox>
    </div>
  </div>
</template>

<script>
  import tableBox from '@/components/table/table'
  export default {
    name: 'knowledge-category',
    components: {
      tableBox
    },
    data() {
      return {
        searchClass:'',
        tableHandler: [
          {label: "修改", type: 'edit', methods: 'editMethods'},
          {label: "删除", type: 'del', methods: 'delMethods'},
        ],
        tableData: [],
        tableHead: [
          {
            label: '分类',
            value: 'name',
            operate: false
          }, {
            label: '操作',
            value: 'name',
            width: '160',
            operate: true,
          }
        ],
        total: 0,
        currentPage: 1,
        pageSize: 10,
      }
    },
    created() {
      this.getClassList()
    },
    mounted() {
      eventBus.$on("reloadClassTable",() => {
        this.getClassList()
      })
    },
    methods: {
      /**
       * 表单操作
       * @param val
       */
      handleOperate(val) {
        if (val.methods == "editMethods") {
          eventBus.$emit('editClass',val.row)
        } else if (val.methods == 'delMethods') {
          this.delClass(val.row.classId)
        }
      },
      /**
       *  分页操作
       * @param val
       */
      pageOperate(val) {
        if (val.type == 'currentChange') {
          this.currentPage = val.val
        } else if (val.type == "sizeChange") {
          this.pageSize = val.val
        }
        this.getClassList()
      },
      getClassList(){
        this.$http.getClassListAPI({
          name:this.searchClass,
          pageNum:this.currentPage,
          pageSize:this.pageSize,
        }).then( res => {
          if(res.status == 1){
            this.tableData = res.data.list
            this.total = res.data.total
          }
        })
      },
      delClass(id){
        this.$http.delClassAPI({
          id
        }).then( res => {
          if(res.status == 1){
            this.getClassList()
            this.$message({
              message: res.msg,
              type: 'success',
            })
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      filterClass(){
        this.getClassList(this.searchClass)
      },
    }
  }
</script>

<style lang="scss">
.knowledge-category{
  .knowledge-management-filter{
    display: flex;
    .input-search-problem{
      width: 300px;
      margin-left: 20px;
    }
  }
}
</style>
